import * as FieldType from "../constants/FieldType";
import {NamaPresenter} from "./NamaPresenter";
import {ajaxJSON} from "../common/NamaCommon";
import ReportExpressionEditorTemplate from "../compiled-templates/ReportExpressionEditorTemplate";
import * as OwnerType from "../constants/OwnerType";
import * as PreferencesRequest from "../constants/PreferencesRequest";
import * as metadata from "../common/Metadata";
import {dropDownFiltering, prepareAllowedValues} from "../widgets/DropDownListWidget";
import {constructDataFromAllowedValues} from "../views/list/ListViewColumns";
import {ReferenceWidget} from "../widgets/ReferenceWidget";
import * as BSEntities from "../constants/BSEntities";
import * as urls from "../constants/NamaURLS";
import {currentUserId} from "../login/LoginPresenter";
import {translateNaMaText} from "../common/Translator";

export class ReportExpressionEditorPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
    }

    start() {
        let that = this;
        this.screenType = {
            Normal: "Normal", Jasper: "Jasper", HyperLink: "HyperLink"
        };
        this.entityName = that.place.entityType;
        this.pendingResponseId = that.place.pendingResponseId;
        this.dataSource1 = that.place.dataSource1;
        this.dataSource2 = that.place.dataSource2;
        this.dataSource3 = that.place.dataSource3;
        this.dataSource4 = that.place.dataSource4;
        this.dataSource5 = that.place.dataSource5;
        this.myScreenType = that.place.screenType;
        this.fieldTitle = that.place.fieldTitle;
        this.breadcrumb = null;
        this.allData = {};
        this.extraJoins = {};
        window.document.body.innerHTML = ReportExpressionEditorTemplate({});
        window.document.body.style.backgroundImage = "none";
        window.document.body.style.backgroundColor = "#f5f1e6";
        if (this.fieldTitle)
            $("#selected-field-title").text(decodeURIComponent(this.fieldTitle));
        this.drawWidgets();
    }

    canNavigate() {
        if (window.okPressed)
            return super.canNavigate();
        return {canNavigate: false, msg: "Are you sure you want to close without saving?"}
    }

    drawWidgets() {
        let that = this;
        this.breadcrumb = this.drawBreadCrumb(this.entityName);
        this.fetchEntityData(this.entityName, (data) => {
            this.drawGridWithData(data.entityData);
            this.readExistedExpression();
            this.selectedFromERP = data.selectedFromERP;
            this.drawSelectedFieldsGrid(data.selectedFromERP);
            if (that.myScreenType === that.screenType.HyperLink) that.drawParametersGrid(data.parametersNames);
        });
        that.existedExpression = {};
        $("#existed-expression").val(JSON.stringify(that.existedExpression));
        if (that.myScreenType === this.screenType.Jasper) {
            $(`<div class='d-flex justify-content-between align-items-center' style="width: 30%">
            <label for='expression-for-drop-down' style='width:35%;text-align:center;margin: 0'>Expression For</label>
            <input id='expression-for-drop-down' style='width:65%'></div>`).insertAfter("#selected-field-title");
            that.lastExpressionForValue = "Details";
            $("#expression-for-drop-down").kendoDropDownList({
                    filter: "contains",
                    dataValueField: "value",
                    dataTextField: "text",
                    dataSource: [
                        {"value": "Details", "text": "Details Field Expression"},
                        {"value": "Group1Footer", "text": "Group 1 Footer Expression"},
                        {"value": "Group1Header", "text": "Group 1 Header Expression"},
                        {"value": "Group2Footer", "text": "Group 2 Footer Expression"},
                        {"value": "Group2Header", "text": "Group 2 Header Expression"},
                        {"value": "Group3Footer", "text": "Group 3 Footer Expression"},
                        {"value": "Group3Header", "text": "Group 3 Header Expression"},
                        {"value": "Group4Footer", "text": "Group 4 Footer Expression"},
                        {"value": "Group4Header", "text": "Group 4 Header Expression"},
                        {"value": "Group5Footer", "text": "Group 5 Footer Expression"},
                        {"value": "Group5Header", "text": "Group 5 Header Expression"},
                        {"value": "Summary", "text": "Summary"},
                    ],
                    change: function (e) {
                        if (!that.existedExpression[that.lastExpressionForValue])
                            that.existedExpression[that.lastExpressionForValue] = {};
                        that.existedExpression[that.lastExpressionForValue].expression = $("#expression").val();
                        that.lastExpressionForValue = e.sender.value();
                        if (!that.existedExpression[that.lastExpressionForValue])
                            that.existedExpression[that.lastExpressionForValue] = {};
                        $("#expression").val(that.existedExpression[that.lastExpressionForValue].expression);
                        $("#existed-expression").val(JSON.stringify(that.existedExpression));
                    }
                }
            ).data("kendoDropDownList");
        } else if (that.myScreenType === that.screenType.HyperLink) {
            let widget = that.reportDefinitionWidget = new ReferenceWidget({
                fieldMetadata: {
                    fieldType: FieldType.Reference, referencedEntityType: BSEntities.ReportDefinition
                }, owner: that,
            });
            $(`<div id="referenceWidgetContainer" class='d-flex align-items-center'>
                <label style='text-align:center;margin: 0 5px 0 0'>Report Definition</label>
                <div id="reportRefWidget"></div>
                </div>`).insertAfter("#selected-field-title");
            $("#reportRefWidget").append(widget.render());
            widget.afterAttach();
            $(`<div class='d-flex align-items-center'>
            <label for='expression-for-drop-down' style='text-align:center;margin: 0 5px 0 0'>Parameter</label>
            <input id='expression-for-drop-down'></div>
            <div class='d-flex align-items-center'>
            <label for='expression-type-drop-down' style='text-align:center;margin: 0 5px 0 0'>Value Type</label>
            <input id='expression-type-drop-down'></div>`).insertAfter("#referenceWidgetContainer");
            that.lastExpressionForValue = "";
            that.hyperLinkExpressionType = $("#expression-type-drop-down").kendoDropDownList({
                filter: "contains", dataSource: ["Expression", "Field", "Parameter"], change: function (e) {

                }
            }).data("kendoDropDownList");
            that.reportParametersWidget = $("#expression-for-drop-down").kendoDropDownList({
                filter: "contains",
                dataValueField: "id",
                dataTextField: "text",
                dataSource: [],
                change: function (e) {
                    if (that.lastExpressionForValue && e.sender.dataSource.data().some(l => l.id === that.lastExpressionForValue)) that.existedExpression[that.lastExpressionForValue] = {
                        expression: $("#expression").val(),
                        type: that.hyperLinkExpressionType.value()
                    };
                    that.lastExpressionForValue = e.sender.value();
                    if (!that.existedExpression[that.lastExpressionForValue])
                        that.existedExpression[that.lastExpressionForValue] = {};
                    if (that.existedExpression[that.lastExpressionForValue].type)
                        that.hyperLinkExpressionType.select(function (dataItem) {
                            return dataItem === that.existedExpression[that.lastExpressionForValue].type;
                        });
                    $("#expression").val(that.existedExpression[that.lastExpressionForValue].expression);
                    $("#existed-expression").val(JSON.stringify(that.existedExpression));
                }
            }).data("kendoDropDownList");
        }
        $(window).on("resize", () => {
            let gridsHeight = window.innerHeight - $("#expression").outerHeight() - $(".toolbar").outerHeight() - $("#breadcrumb").outerHeight();
            $("#grid").height(gridsHeight * 2 / 3);
            $("#selectedFieldsGrid").height(gridsHeight / 3);
            if (that.myScreenType === this.screenType.HyperLink) {
                $("#parametersGrid").height(gridsHeight / 3);
                $("#parametersGrid").width(window.innerWidth * 2 / 5);
                $("#selectedFieldsGrid").width(window.innerWidth * 3 / 5);
            }
            this.grid.resize();
            this.selectedFieldsGrid.resize();
            this.parametersGrid.resize();
        });
        window.onunload = function (e) {
            if (window.okPressed) return null;
            ajaxJSON("reportExpressionEditor", {
                pendingResponseId: that.pendingResponseId,
                action: "cancel"
            });
        }
        $("#saveBtn").on('click', () => {
            if (that.myScreenType === this.screenType.Jasper) {
                if (that.existedExpression && !that.existedExpression[that.lastExpressionForValue])
                    that.existedExpression[that.lastExpressionForValue] = {};
                that.existedExpression[that.lastExpressionForValue].expression = $("#expression").val();
            } else if (that.myScreenType === this.screenType.HyperLink && that.existedExpression && that.existedExpression.reportId) {
                if (that.lastExpressionForValue && that.reportParametersWidget.dataSource.data().some(l => l.id === that.lastExpressionForValue)) that.existedExpression[that.lastExpressionForValue] = {
                    expression: $("#expression").val(), type: that.hyperLinkExpressionType.value()
                };
            }
            $("#existed-expression").val(JSON.stringify(that.existedExpression));
            window.okPressed = true;
            window.onunload = null;
            let result = $("#expression").val();
            if ((that.myScreenType === that.screenType.HyperLink && that.existedExpression.reportId) || that.myScreenType === that.screenType.Jasper) result = JSON.stringify(that.existedExpression);
            ajaxJSON("reportExpressionEditor", {
                pendingResponseId: this.pendingResponseId, result: result,
                action: "done"
            })
            window.close();
        })
    }

    drawSelectedFieldsGrid(data) {
        let that = this;
        let height = window.innerHeight - $("#expression").outerHeight() - $(".toolbar").outerHeight() - $("#breadcrumb").outerHeight();
        let selectedFieldsGrid = this.selectedFieldsGrid = $("#selectedFieldsGrid").kendoGrid({
            dataSource: {
                data: data,
                pageSize: 10
            },
            pageable: true,
            height: height / 3,
            columns: [
                {draggable: true, width: "40px"},
                {field: "finalId", title: "Full Id"},
                {field: "arabicName", title: "Arabic Name"},
                {field: "englishName", title: "English Name"},
                {
                    title: "Go To", template: (i) => {
                        let cellHtml = `<div class="d-flex justify-content-center">`;
                        cellHtml += `<button title="Go To Parent" class="btn btn-warning btn-sm d-block goToParentBtn mx-2" final-id='${i.finalId}'>
                        <i class="fa-solid fa-arrow-right" style="font-size: 16px"></i></button>`;
                        cellHtml += that.appendReferenceButtonToCellIfNeeded(i);
                        cellHtml += `</div>`;
                        return cellHtml;
                        return ``;
                    }
                }, {
                    field: "selectedRow", width: "80px", title: "Select", template: (i) => {
                        return `<button class="select-item btn btn-success" uid="${i.uid}">Select</button>`
                    }
                },],
            editable: "inline",
            reorderable: {
                rows: true
            },
        }).getKendoGrid();
        $("#selectedFieldsGrid").on("click", ".select-item", function (e) {
            let uid = e.target.attributes['uid'].value;
            let currentElement = selectedFieldsGrid.dataSource.getByUid(uid);
            that.onSelectedClick(currentElement, true);
        });
        $("#selectedFieldsGrid").on("click", ".goToParentBtn", function (e) {
            that.onGoToParentField($(e.target).closest(".goToParentBtn").attr('final-id'));
        });
        $("#selectedFieldsGrid").on("click", ".fetch-reference", function (e) {
            that.onFetchClicked($(e.target).closest(".fetch-reference").attr('referenceTo'), $(e.target).closest(".fetch-reference").attr('fullName'));
        });
        $("#selectedFieldsGrid").on("click", ".fetch-generic-reference", function (e) {
            that.onGenericRefFetchClicked($(e.target).closest(".fetch-generic-reference"), $(e.target).closest(".fetch-generic-reference").attr('finalId'), $(e.target).closest(".fetch-generic-reference").attr('uid'))
        });
    }

    readExistedExpression() {
        let that = this;
        ajaxJSON("reportExpressionEditor", {
            pendingResponseId: this.pendingResponseId,
            action: "readExistedExpression"
        }, (data) => {
            if (that.myScreenType === that.screenType.Jasper) {
                if (!data)
                    return;
                if (data.trim().startsWith('{')) {
                    that.existedExpression = JSON.parse(data);
                    if (!that.existedExpression[that.lastExpressionForValue])
                        that.existedExpression[that.lastExpressionForValue] = {};
                    $("#expression").val(that.existedExpression[that.lastExpressionForValue].expression);
                } else {
                    that.existedExpression[that.lastExpressionForValue] = {"expression": data};
                    $("#expression").val(that.existedExpression[that.lastExpressionForValue].expression);
                }
            } else if (that.myScreenType === that.screenType.HyperLink && data && data.trim().startsWith('{')) {
                that.existedExpression = JSON.parse(data);
                if (that.existedExpression["reportId"]) {
                    that.reportDefinitionWidget.setValue(that.existedExpression["reportDefinition"]);
                    that.onDataChanged("", that.existedExpression["reportDefinition"], true)
                } else {
                    $("#expression").val(data);
                }
            } else {
                that.existedExpression = data ? data : {};
                $("#expression").val(data);
            }
            $("#existed-expression").val(JSON.stringify(that.existedExpression));
        }, (e) => {
            console.log(e);
        })
    }

    drawBreadCrumb(entityName) {
        let that = this;
        return $("#breadcrumb").kendoBreadcrumb({
            items: [{
                type: "rootItem",
                text: entityName,
                showText: true,
                entityType: entityName,
                parentFullName: "",
                tableType: that.tableType
            }], click: (e) => {
                let index = this.breadcrumb.items().indexOf(e.item);
                for (let i = index + 1; i < this.breadcrumb.items().length; i++) {
                    let fullFieldId = this.calcCurrentFullFieldIdFromArray(this.breadcrumb.items().slice(0, i + 1));
                    let data = this.breadcrumb.items()[i].data;
                    if (i === this.breadcrumb.items().length - 1) data = this.grid.dataSource.data();
                    this.allData[fullFieldId] = data;
                }
                this.breadcrumb.items().splice(index + 1, this.breadcrumb.items().length - index);
                this.grid.dataSource.data(e.item.data);
                this.grid.refresh();
            }
        }).getKendoBreadcrumb();
    }

    calcCurrentFullFieldIdFromArray(items) {
        return items.filter(l => l.type !== "rootItem").map(l => l.parentPropertyName).join(".");
    }

    fetchEntityData(entityName, callback, fullName) {
        let that = this;
        if (fullName && this.allData[fullName]) {
            callback(this.allData[fullName]);
            return;
        }
        ajaxJSON("wizardFieldsSelection", {
            pendingResponseId: this.pendingResponseId,
            fetchEntityModel: entityName,
            mainEntityName: that.entityName,
            action: "fetchEntityData",
            dataSource1: that.dataSource1,
            dataSource2: that.dataSource2,
            dataSource3: that.dataSource3,
            dataSource4: that.dataSource4,
            dataSource5: that.dataSource5,
        }, (data) => {
            let entityJson = data.entityData;
            let lastItemInBreadCrumb = that.breadcrumb.items()[that.breadcrumb.items().length - 1];
            if (lastItemInBreadCrumb.entityType === entityJson.tableName) {
                lastItemInBreadCrumb.tableType = entityJson.tableType;
                if (entityJson.tableType === 'DetailLine') {
                    lastItemInBreadCrumb.detailParentEntity = entityJson.detailParentEntity;
                    lastItemInBreadCrumb.detailFullName = entityJson.detailFullName;
                }
            }
            let entityDataArray = entityJson.properties;
            entityDataArray = entityDataArray.concat(that.fetchAllDetailsProps(entityJson));
            entityDataArray.forEach(function (element) {
                element.display = that.isReferenceField(element) || element.fieldType === 'Genericreference' ? 'block' : 'none';
                element.finalId = that.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + element.fullName;
            });
            data.entityData = entityDataArray;
            callback(data);
        }, (e) => {
            console.log(e);
        })
    }

    isReferenceField(element) {
        return element.fieldType === 'Reference' || element.referenceTo;
    }

    fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() {
        return this.calcCurrentFullFieldIdFromBreadCrumb() ? this.calcCurrentFullFieldIdFromBreadCrumb() + "." : ""
    }

    calcCurrentFullFieldIdFromBreadCrumb() {
        return this.calcCurrentFullFieldIdFromArray(this.breadcrumb.items());
    }

    fetchAllDetailsProps(entityJson) {
        let detailsProps = [];
        let detailsArray = entityJson.details;
        for (let i = 0; i < detailsArray.length; i++) {
            let currentDetails = detailsArray[i];
            let detailPropertiesArray = currentDetails.properties;
            detailsProps = detailsProps.concat(detailPropertiesArray);
        }
        return detailsProps;
    }

    drawGridWithData(data) {
        let that = this;
        let height = window.innerHeight - $("#expression").outerHeight() - $(".toolbar").outerHeight() - $("#breadcrumb").outerHeight();
        let grid = this.grid = $("#grid").kendoGrid({
            dataSource: {
                data: data,
                pageSize: 25,
            },
            height: height * 2 / 3,
            scrollable: true,
            filterable: true,
            sortable: true,
            toolbar: ["search"],
            search: {
                fields: [
                    {name: "fullName", operator: "contains"},
                    {name: "arabicName", operator: "contains"},
                    {
                        name: "englishName", operator: "contains"
                    }],
            },
            columns: [
                {field: "fullName", width: 300, title: "Full Name"},
                {
                    field: "fieldType", width: 120, title: "Reference", nullable: true, template: (i) => {
                        let cellHtml = `<div class="d-flex justify-content-center">`;
                        cellHtml += that.appendReferenceButtonToCellIfNeeded(i);
                        cellHtml += that.appendManualJoinButtonToCellIfNeeded(i);
                        cellHtml += `</div>`;
                        return cellHtml;
                    }
                },
                {field: "arabicName", title: "Arabic Name"},
                {field: "englishName", title: "English Name"},
                {field: "fieldType", title: "Field Type"},
                {
                    field: "selectedRow", width: "80px", title: "Select", template: (i) => {
                        return `<button class="select-item btn btn-success" uid="${i.uid}">Select</button>`
                    }
                },
            ],
            pageable: {
                position: "bottom",
                refresh: true,
                pageSizes: [25, 50, 75, 100, "all"],
                buttonCount: 5,
            },
        }).getKendoGrid();
        $("#grid").on("click", ".fetch-reference", function (e) {
            that.onFetchClicked($(e.target).closest(".fetch-reference").attr('referenceTo'), $(e.target).closest(".fetch-reference").attr('fullName'));
        });
        $("#grid").on("click", ".fetch-generic-reference", function (e) {
            that.onGenericRefFetchClicked($(e.target).closest(".fetch-generic-reference"), $(e.target).closest(".fetch-generic-reference").attr('finalId'), $(e.target).closest(".fetch-generic-reference").attr('uid'))
        });
        $("#grid").on("click", ".select-item", function (e) {
            let uid = e.target.attributes['uid'].value;
            let currentElement = grid.dataSource.getByUid(uid);
            that.onSelectedClick(currentElement);
        });
        if (that.myScreenType === that.screenType.Jasper) {
            $(`<div style="width:50%" class="d-flex justify-content-between m-0">
            <div class='d-flex justify-content-between align-items-center' style="width: 45%">
            <label for='jasper-function-drop-down' style='width:30%;text-align:center;margin: 0'>Function</label>
            <input id='jasper-function-drop-down' style='width:65%'></div>
            <div class='d-flex justify-content-between align-items-center' style="width: 45%">
            <label for='reset-group-drop-down' style='width:35%;text-align:center;margin: 0'>Reset Group</label>
            <input id='reset-group-drop-down' style='width:60%'></div>
            </div>`).appendTo($(".k-toolbar"))
            $("#jasper-function-drop-down").kendoDropDownList({
                filter: "contains",
                dataValueField: "value",
                dataTextField: "text",
                dataSource: [
                    {"value": "", "text": ""},
                    {"value": "count", "text": "Count"},
                    {"value": "sum", "text": "Sum"},
                    {"value": "avg", "text": "Average"},
                    {"value": "lowest", "text": "Lowest"},
                    {"value": "highest", "text": "Highest"},
                    {"value": "standardDeviation", "text": "Standard Deviation"},
                    {"value": "variance", "text": "Variance"},
                    {"value": "first", "text": "First"},
                    {"value": "distinctCount", "text": "Distinct Count"},
                ],
                change: function (e) {
                    that.jasperFunctionDropDownValue = e.sender.value();
                }
            }).data("kendoDropDownList");
            $("#reset-group-drop-down").kendoDropDownList({
                filter: "contains",
                dataValueField: "value",
                dataTextField: "text",
                dataSource: [
                    {"value": "", "text": ""},
                    {"value": "Report", "text": "Report"},
                    {"value": "Page", "text": "Page"},
                    {"value": "Column", "text": "Column"},
                    {"value": "Group1", "text": "Group 1"},
                    {"value": "Group2", "text": "Group 2"},
                    {"value": "Group3", "text": "Group 3"},
                    {"value": "Group4", "text": "Group 4"},
                    {"value": "Group5", "text": "Group 5"},
                ],
                change: function (e) {
                    that.resetGroupDropDownValue = e.sender.value();
                }
            }).data("kendoDropDownList");
        }
        $(`<div class="form-check">
                  <input class="form-check-input" type="checkbox" id="allowManualJoinForAllFieldTypes">
                  <label class="form-check-label" for="allowManualJoinForAllFieldTypes">Allow Manual Join For All Field Types</label>
                  </div>`).appendTo($(".k-toolbar"));
        $("#allowManualJoinForAllFieldTypes").change(function () {
            that.grid.dataSource.data(that.grid.dataSource.data())
        })
        $("#grid").on("click", ".fetch-manual-join", function (e) {
            that.onManualJoinClicked($(e.target).closest(".fetch-manual-join"));
        });
    }

    onManualJoinClicked(target) {
        let that = this;
        let referenceTo = target.attr('referenceTo');
        let fullName = target.attr('fullName');
        let uid = target.attr('uid');
        let dialog = this.buildManualJoinDialog();
        that.manualFieldsDropDown = $("#manual-fields-drop-down").kendoDropDownList({
            filter: "contains",
            enable: false,
            dataValueField: "value",
            dataTextField: "text",
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            }
        }).data("kendoDropDownList");
        that.manualEntitiesDropDown = $("#manual-entities-drop-down").kendoDropDownList({
            filter: "contains",
            enable: false,
            dataValueField: "value",
            dataTextField: "text",
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            },
            change: function (e) {
                that.manualFieldsDropDown.value("");
                that.manualFieldsDropDown.enable(false);
                if (e.sender.value()) {
                    ajaxJSON("wizardFieldsSelection", {
                        referenceTo: referenceTo,
                        fullName: fullName,
                        entityName: e.sender.value(),
                        action: "fetchManualJoinFieldsByEntity",
                        allowManualJoinForAllFieldTypes: $("#allowManualJoinForAllFieldTypes").prop('checked')
                    }, (data) => {
                        data.unshift({value: "", text: ""});
                        that.manualFieldsDropDown.dataSource.data(data);
                        that.manualFieldsDropDown.enable(true);
                    });
                }
            }
        }).data("kendoDropDownList");
        that.manualTableTypeDropDown = $("#manual-table-type-drop-down").kendoDropDownList({
            filter: "contains",
            dataValueField: "value",
            dataTextField: "text",
            dataSource: [
                {"value": "", "text": ""},
                {"value": "Entity", "text": "Entity"},
                {"value": "DetailLine", "text": "Detail Line"},
                {"value": "SystemTable", "text": "System Table"}],
            change: function (e) {
                that.manualEntitiesDropDown.value("");
                that.manualEntitiesDropDown.enable(false);
                if (e.sender.value()) {
                    ajaxJSON("wizardFieldsSelection", {
                        tableType: e.sender.value(),
                        action: "fetchEntitiesByTableType"
                    }, (data) => {
                        data.unshift({value: "", text: ""});
                        that.manualEntitiesDropDown.dataSource.data(data);
                        that.manualEntitiesDropDown.enable(true);
                    });
                }
            }
        }).data("kendoDropDownList");
        dialog.open();
        dialog.bind("close", function () {
            that.manualTableTypeDropDown.destroy();
            that.manualFieldsDropDown.destroy();
            that.manualEntitiesDropDown.destroy();
            dialog.destroy();
        });

        $("#manual-join-dialog").on("click", ".manual-join-ok-button", function () {
            if (!that.manualTableTypeDropDown.value() || !that.manualEntitiesDropDown.value() || !that.manualFieldsDropDown.value())
                return;
            let gridData = that.grid.dataSource.data();
            let generatedFromItem = that.grid.dataSource.getByUid(uid);
            let selectedField = that.manualFieldsDropDown.dataItem();
            if (gridData.filter(f => f.fullName === selectedField.fullName)[0] || !selectedField) {
                dialog.close();
                return;
            }
            selectedField.display = "block";
            selectedField.finalId = that.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + selectedField.fullName;
            gridData.splice(gridData.indexOf(generatedFromItem) + 1, 0, selectedField);
            that.grid.dataSource.data(gridData);
            dialog.close();
            $("#manual-join-dialog").remove();
        });
    }

    buildManualJoinDialog() {
        return $("<div id='manual-join-dialog'></div>").kendoDialog({
            width: "550px",
            title: "Select Manual Join",
            closable: true,
            modal: false,
            content: "<div class='d-flex flex-column align-items-center'>" +
                "<div class='d-flex justify-content-around align-items-center mb-2' style='width:100%'>" +
                "<label for='manual-table-type-drop-down'  style='width:20%;text-align:center;margin: 0'>Table Type</label>" +
                "<input id='manual-table-type-drop-down' style='width:80%'></div>" +
                "<div class='d-flex justify-content-around align-items-center my-2' style='width:100%'>" +
                "<label for='manual-entities-drop-down'  style='width:20%;text-align:center;margin: 0'>Join Entity</label>" +
                "<input id='manual-entities-drop-down' style='width:80%'></div>" +
                "<div class='d-flex justify-content-around align-items-center my-2' style='width:100%'>" +
                "<label for='manual-fields-drop-down' style='width:20%;text-align:center;margin: 0'>Join Field</label>" +
                "<input id='manual-fields-drop-down' style='width:80%'></div>" +
                "<button class='btn btn-success manual-join-ok-button mt-2' style='width:30%;'>Ok</button>" + "</div>",
            close: function () {
                this.destroy();
            }
        }).data("kendoDialog");
    }

    onSelectedClick(currentElement, isFromSelectedGrid) {
        let fullName = currentElement.fullName;
        if ((this.myScreenType !== this.screenType.HyperLink || !this.existedExpression.reportId) && (currentElement.fieldType === 'Reference' || currentElement.fieldType === 'Genericreference'))
            fullName += ".code";
        let id = this.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + fullName;
        if (isFromSelectedGrid)
            id = (currentElement.fullParentFieldId ? currentElement.fullParentFieldId + "." : "") + fullName;
        if (this.myScreenType === this.screenType.Jasper && this.jasperFunctionDropDownValue && this.resetGroupDropDownValue)
            id = this.jasperFunctionDropDownValue + "(" + id + "," + this.resetGroupDropDownValue + ")";
        let cursorPos = $('#expression').prop('selectionStart');
        let v = $('#expression').val();
        let textBefore = v.substring(0, cursorPos);
        let textAfter = v.substring(cursorPos, v.length);
        $('#expression').val(textBefore + "@{" + id + "}@" + textAfter);
        $('#expression').focus();
    }

    onGenericRefFetchClicked(e, fieldId, uid) {
        let that = this;
        let req = {};
        let lastItemInBreadCrumb = that.breadcrumb.items()[that.breadcrumb.items().length - 1];
        let entityType = lastItemInBreadCrumb.entityType
        let entityTableType = lastItemInBreadCrumb.tableType;
        if (e.attr('entityTableType') !== "undefined") {
            entityTableType = e.attr('entityTableType');
            entityType = fieldId.slice(fieldId.lastIndexOf("#") + 1, fieldId.lastIndexOf("{"));
            fieldId = fieldId.slice(fieldId.lastIndexOf(":\"") + 2, fieldId.lastIndexOf("\"}"));
        }
        if (entityTableType === "DetailLine") {
            entityType = lastItemInBreadCrumb.detailParentEntity;
            fieldId = lastItemInBreadCrumb.detailFullName + "." + fieldId;
        } else if (entityTableType && entityTableType === "SystemTable") {
            entityType = "MeetingRemark";
            fieldId = "ref20";
        }
        req.owner = {ownerType: OwnerType.Entity, ownerId: entityType};
        req.properties = [PreferencesRequest.META_DATA];
        metadata.fetchPreferences(req, (preferences) => {
            let entityMetadata = preferences[PreferencesRequest.META_DATA];
            let dialog = that.drawDialogForGenericRef(entityMetadata, fieldId);
            dialog.open();

            $("#dialog").on("click", ".entity-select-btn", function () {
                let gridData = that.grid.dataSource.data();
                let generatedFromItem = that.grid.dataSource.getByUid(uid);
                let selectedEntity = that.dropDown.value();
                if (gridData.filter(f => f.fullName === generatedFromItem.fullName + "#" + selectedEntity)[0] || !selectedEntity) {
                    dialog.close();
                    dialog.destroy();
                    return;
                }
                let newItem = {
                    arabicName: generatedFromItem.arabicName,
                    englishName: generatedFromItem.englishName,
                    display: "block",
                    fieldType: "Reference",
                    referenceTo: selectedEntity,
                    fullName: generatedFromItem.fullName + "#" + selectedEntity,
                    finalId: generatedFromItem.finalId
                };
                gridData.splice(gridData.indexOf(generatedFromItem) + 1, 0, newItem);
                that.grid.dataSource.data(gridData);
                dialog.close();
                $("#dialog").remove();
            });
        })
    };

    drawDialogForGenericRef(entityMetadata, fieldId) {
        let that = this;
        let dialog = $("<div id='dialog'></div>").kendoDialog({
            width: "450px",
            title: "Select Entity Type",
            closable: true,
            modal: false,
            content: "<div class='d-flex flex-column align-items-center'><input id='generic-compo' class='my-2'>"
                + "<button class='btn btn-success entity-select-btn'>Ok</button></div>",
            close: function () {
                that.dropDown.destroy();
                dialog.destroy();
            }
        }).data("kendoDialog");
        let allowedEntityTypes = [{text: "", value: "", originText: ""}];
        fieldId = fieldId.substring(that.calcCurrentFullFieldIdFromBreadCrumb().length ? that.calcCurrentFullFieldIdFromBreadCrumb().length + 1 : 0)
        let allowedValues = prepareAllowedValues(metadata.findFieldMetadata(fieldId, entityMetadata));
        if (allowedValues) allowedEntityTypes = constructDataFromAllowedValues(allowedValues);
        that.dropDown = $("#generic-compo").kendoDropDownList({
            filter: "contains",
            dataValueField: "value",
            dataTextField: "text",
            dataSource: allowedEntityTypes,
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            }
        }).data("kendoDropDownList");
        return dialog;
    }

    onFetchClicked(referenceTo, parentPropertyName) {
        $(".k-grid-search>input").val("");
        this.grid.dataSource.filter([]);
        this.breadcrumb.items()[this.breadcrumb.items().length - 1].data = this.grid.dataSource.data();
        this.fetchEntityData(referenceTo, (data) => this.grid.dataSource.data(data.entityData),
            this.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + parentPropertyName);
        this.breadcrumb.items().push({
            type: "item",
            text: parentPropertyName + " (" + referenceTo + ")",
            showText: true,
            entityType: referenceTo,
            parentPropertyName: parentPropertyName,
            tableType: this.tableType,
        });
        this.breadcrumb.value(this.breadcrumb.items().map(e => e.text).join("/"));
    };

    appendReferenceButtonToCellIfNeeded(element) {
        if (this.isReferenceField(element) || element.fullName.includes("#")) {
            return `<button title="Go Inside Reference" class="btn btn-success btn-sm fetch-reference mx-2" referenceTo='${element.referenceTo}' 
                        fullName='${element.fullName}'><i class="fa-solid fa-arrow-right" style="font-size: 16px"></i></button>`
        } else if (element.fieldType === 'Genericreference') {
            return `<button title="Go Inside Reference" class="btn btn-success btn-sm fetch-reference mx-2" referenceTo='EntitySystemEntry'
                        fullName='${element.fullName}#EntitySystemEntry{"joinBy":"targetId"}'><i class="fa-solid fa-arrow-right" style="font-size: 20px"></i></button>
                        <button title="Go Inside Generic Reference" class="btn btn-primary btn-sm fetch-generic-reference mx-2"
                        finalId='${element.finalId}' uid='${element.uid}' entityTableType="${element.entityTableType}">
                        <i class="fa-solid fa-arrow-right" style="font-size: 20px"></i></button>`
        } else {
            return ``;
        }
    }

    appendManualJoinButtonToCellIfNeeded(element) {
        if (element.fullName.includes("#"))
            return ``;
        else if ($("#allowManualJoinForAllFieldTypes") && $("#allowManualJoinForAllFieldTypes").prop('checked'))
            return `<button title="Open Manual Join Dialog" class="btn btn-secondary btn-sm fetch-manual-join mx-2" referenceTo='${element.referenceTo}' 
                        fullName='${element.fullName}' uid='${element.originalUid ? element.originalUid : element.uid}'>
                        <i class="fa-solid fa-hand-holding"></i></button>`;
        else if (this.isReferenceField(element) || element.fieldType === 'Genericreference' || element.fullName === 'id')
            return `<button title="Open Manual Join Dialog" class="btn btn-secondary btn-sm fetch-manual-join mx-2" referenceTo='${element.referenceTo}' 
                        fullName='${element.fullName}' uid='${element.originalUid ? element.originalUid : element.uid}'>
                        <i class="fa-solid fa-hand-holding"></i></button>`;
        else
            return "";
    }

    async onGoToParentField(finalId) {
        let element = this.selectedFromERP.filter(l => l.finalId === finalId)[0];
        if (!element)
            element = this.selectedFieldsGrid.dataSource.data().filter(l => l.finalId === finalId)[0];
        if (!element || !element.parentsPath)
            return;
        this.breadcrumb.items([this.breadcrumb.items()[0]]);
        this.grid.dataSource.data(this.breadcrumb.items()[0].data);
        this.grid.refresh();
        for (let parent of element.parentsPath) {
            let first = this.grid.dataSource.data().filter(f => f.fullName === parent)[0];
            await this.onFetchClicked(first.referenceTo, first.fullName);
        }
    }

    addDataWidget(widget) {
        this.extraCriteriaWidget = widget;
    }

    rootElement() {
        return $(".screen");
    }

    onDataChanged(id, newValue, fromExisted) {
        let that = this;
        if (!newValue) {
            that.existedExpression = {};
            that.reportParametersWidget.dataSource.data([]);
            $("#existed-expression").val(JSON.stringify(that.existedExpression));
            return;
        }
        let dataItem = that.reportDefinitionWidget.findElement().data("kendoComboBox").dataItem();
        if (!dataItem && !newValue.id) {
            that.existedExpression = {};
            that.reportParametersWidget.dataSource.data([]);
            $("#existed-expression").val(JSON.stringify(that.existedExpression));
            return;
        }
        let reportId = dataItem ? dataItem.id : newValue.id;
        if (typeof that.existedExpression !== 'object' || !fromExisted) that.existedExpression = {};
        that.existedExpression['reportId'] = reportId;
        ajaxJSON(urls.FetchReportMetadata, {
            request: JSON.stringify({
                id: reportId, entityType: BSEntities.ReportDefinition, userId: currentUserId()
            })
        }, (result) => {
            let questionFields = result.data.metadata.questionFields;
            that.existedExpression['reportDefinition'] = result.data.report;
            questionFields.forEach(l => {
                if (!that.existedExpression[l.id]) that.existedExpression[l.id] = {};
                l.text = translateNaMaText(l.title) ? translateNaMaText(l.title) : l.id;
            });
            $("#existed-expression").val(JSON.stringify(that.existedExpression));
            that.reportParametersWidget.dataSource.data(questionFields);
            if (questionFields.length) {
                that.reportParametersWidget.select(0);
                that.reportParametersWidget.trigger("change");
            }
        });
    }

    drawParametersGrid(parametersNames) {
        let that = this;
        let height = window.innerHeight - $("#expression").outerHeight() - $(".toolbar").outerHeight() - $("#breadcrumb").outerHeight();
        let width = window.innerWidth;
        $(`<div id="parametersGrid"></div>`).insertAfter("#selectedFieldsGrid");
        that.selectedFieldsGrid.setOptions({
            width: width * 3 / 5
        });
        let data = [];
        if (parametersNames.length) parametersNames.forEach(l => data.push({text: `$P{${l}`, value: l}));
        let parametersGrid = that.parametersGrid = $("#parametersGrid").kendoGrid({
            width: width * 2 / 5, height: height / 3, dataSource: {
                data: data,
            }, columns: [{field: "text", title: "Parameter"}, {
                title: "Select",
                template: (i) => `<button class="select-parameter btn btn-success" parameterName="${i.value}">Select</button>`
            },]
        }).getKendoGrid();
        $("#parametersGrid").on("click", ".select-parameter", function (e) {
            let parameterName = $(e.target).attr('parameterName');
            that.onParameterSelectClick(parameterName);
        });
    }

    onParameterSelectClick(parameterName) {
        let cursorPos = $('#expression').prop('selectionStart');
        let v = $('#expression').val();
        let textBefore = v.substring(0, cursorPos);
        let textAfter = v.substring(cursorPos, v.length);
        $('#expression').val(textBefore + "@" + parameterName + textAfter);
        $('#expression').focus();
    }
}